var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signing-wait-container"},[_c('div',{staticClass:"wait-card"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa","size":"28px"}}),_c('h2',[_vm._v("正在完成合同签署")]),_c('p',[_vm._v("请稍候，不要关闭页面...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }